<template>
  <div
    class="auth-email-confirmation"
    :class="{ 'auth-email-confirmation_error': !!error }"
  >
    {{ !!error ? error : message }}
  </div>
</template>

<script>
import apiUser from "@/api/user";
import getError from "@/helpers/error";

export default {
  name: "AuthEmailConfirmation",

  data() {
    return {
      message: this.$t("auth.emailConfirmation.title"),
      error: ""
    };
  },

  mounted() {
    apiUser
      .confirm(this.$route.params.id, this.$route.params.token)
      .then(() => {
        this.message = this.$t("auth.emailConfirmation.successMessage");

        setTimeout(() => {
          this.$router.push({ name: "login" });
        }, 2000);
      })
      .catch(response => {
        this.error = getError(response);
      });
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.auth-email-confirmation {
  @include description();

  padding: 48px 80px;
  width: 460px;
  box-sizing: border-box;

  text-align: center;
  line-height: normal;

  @include respond-down(md) {
    width: calc(100vw - 16 * 2px);
    min-width: 228px;
    max-width: 375px;

    padding: 24px;
  }

  &_error {
    color: #ea5330;
  }
}
</style>
